import React from "react";
import { PurchaseButton } from "./PurchaseButton";
import { CtaMicrocopy } from "./CtaMicrocopy";
import { ctaMicrocopy, offer } from "../data/offer";
export function ClosingSection() {
  return <section className="bg-navy" data-id="element-33" data-mp="12tda8itdcgg8">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-16 md:py-24 lg:grid-cols-[1.1fr_1fr]" data-id="element-34" data-mp="12uetvbogab9k">
        <div className="text-center lg:text-left" data-id="element-35" data-mp="xsftmao0bugu">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-gold md:text-[13px]" data-id="element-36" data-mp="1cq85msuci0qa">
            The Hard Questions Will Come.
          </p>
          <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-white md:text-5xl" data-id="element-37" data-mp="1ljbpbivl39td">
            When Someone Asks Your Child, “<span className="text-gold" data-id="element-38" data-mp="1hi9pp0xr8vqv">WHY</span> Do You Believe?” Will They Know What
            to Say?
          </h2>
          <div className="mt-6 space-y-3 text-lg leading-relaxed text-white/80" data-id="element-39" data-mp="1vferupuclagu">
            <p data-id="element-40" data-mp="1qjzgq5nq5so4">Your child may know every Bible story.</p>
            <p data-id="element-41" data-mp="22cvpo72olrgm">They may remember the songs, the verses, and the lessons they've heard at church.</p>
            <p className="font-semibold text-white" data-id="element-42" data-mp="27axaoxjo40uq">
              But when someone challenges their faith… Will they understand the reasons behind what they've been taught?
            </p>
            <p data-id="element-43" data-mp="2gbvi7ptbeqi2">Don't wait until those questions catch your family unprepared.</p>
            <p className="font-semibold text-white" data-id="element-44" data-mp="2g9siuf69vl0o">Start exploring meaningful answers together today.</p>
          </div>
        </div>

        <div className="rounded-[2rem] bg-white p-7 text-center md:p-10" data-id="element-45" data-mp="2q9j9u6vmjhw0">
          <p className="font-display text-3xl font-extrabold tracking-tight text-navy md:text-4xl" data-id="element-46" data-mp="2v19qeul5n1vv">
            {offer.productName}
          </p>
          <p className="mt-1 font-display text-lg font-bold text-royal" data-id="element-47" data-mp="2zyt67yxi3mpx">{offer.productSubtitle}</p>
          <p className="mx-auto mt-4 max-w-xs rounded-xl bg-canvas px-4 py-3 text-[15px] font-semibold text-ink" data-id="element-48" data-mp="3430s7ockqokg">
            6 Digital Volumes + Question-Based Lessons + 5 Bonus Guides
          </p>

          <p className="mt-6 text-base text-ink-soft" data-id="element-49" data-mp="18zciu18sz7qh">
            Regular Price: <s data-id="element-50" data-mp="14xr0i0di218w">{offer.regularPrice}</s>
          </p>
          <p className="mt-1 flex items-baseline justify-center gap-3" data-id="element-51" data-mp="14uv44ghavkmk">
            <span className="font-display text-base font-extrabold uppercase tracking-wider text-ink" data-id="element-52" data-mp="1ip4fr24dkcy4">Today: Only</span>
            <span className="font-display text-6xl font-extrabold leading-none text-navy md:text-7xl" data-id="element-53" data-mp="1dwbamd4zv2li">{offer.price}</span>
          </p>

          <div className="mt-7" data-id="element-54" data-mp="1nnphx736t6p7">
            <PurchaseButton label={`Yes! I Want to Prepare My Child's Faith — ${offer.price}`} data-id="element-55" data-mp="1nmnvk6gq0xs6" />
            <CtaMicrocopy items={ctaMicrocopy.closing} data-id="element-56" data-mp="21m5mardkul46" />
          </div>
        </div>
      </div>
    </section>;
}